export const services = [
  {
    id: 7,
    title: 'Commercial Sector: Façade Engineering',
    previewDescription: 'Tailored façade solutions for commercial projects.',
    description: 'We deliver tailored engineering solutions to keep your commercial projects running smoothly. From glazing and cladding design to wind load and thermal analyses, our services are precise, code-compliant, and ready for implementation. Boost efficiency with cost-effective, code-compliant facade solutions, delivering speed, accuracy, and clear documentation.',
    icon: '/assets/images/facade-bg.jpg',
    bgImage: '/assets/images/facade-bg.jpg',
    subServices: [
      {
        id: 701,
        title: 'Certified Wind Load Analysis',
        description: 'Our certified wind load analysis ensures your building façade can withstand environmental forces through detailed computational models and simulations.',
        image: '/assets/images/Icons/storm.png',
        benefits: [
          'ASCE 7 Compliant Calculations',
          'Site-Specific Wind Pressure Mapping',
          'Corner and Edge Zone Analysis',
          'Dynamic Wind Response Evaluation'
        ],
        process: [
          'Site assessment and data collection',
          'Computer modeling and simulation',
          'Detailed analysis and report generation',
          'Recommendation for optimized design'
        ]
      },
      {
        id: 702,
        title: 'Thermal Analysis (NFRC Certified)',
        description: 'We provide NFRC-certified thermal analysis to optimize energy efficiency and occupant comfort in commercial facades.',
        image: '/assets/images/Icons/hot.png',
        benefits: [
          'Energy Cost Reduction',
          'Condensation Risk Assessment',
          'LEED Certification Support',
          'Thermal Bridge Mitigation'
        ],
        process: [
          'Baseline performance assessment',
          'Thermal modeling and simulation',
          'Material optimization recommendations',
          'Compliance documentation preparation'
        ]
      },
      {
        id: 703,
        title: 'Glazing Structural Calculations',
        description: 'Structural calculations for glazing systems in low, mid, and high-rise buildings, ensuring safety and compliance.',
         image: '/assets/images/Icons/summation.png',
        benefits: [
          'Optimized Material Utilization',
          'Cost-Effective Solutions',
          'Code Compliance Assurance',
          'Integration with Building Systems'
        ],
        process: [
          'Design requirement assessment',
          'System selection and customization',
          'Structural calculation and verification',
          'Detailed drawings and specifications'
        ]
      },
      {
        id: 704,
        title: 'Glazing Support Structures Design',
        description: 'Design and structural analysis of glazing support structures to ensure stability and integration with building facades.',
        image: '/assets/images/Icons/wrench.png',
        benefits: [
          'Enhanced Structural Integrity',
          'Customized Support Solutions',
          'Seamless Facade Integration',
          'Compliance with Safety Standards'
        ],
        process: [
          'Load analysis and structural modeling',
          'Design of support frameworks',
          'Integration with glazing systems',
          'Final verification and documentation'
        ]
      },
      {
        id: 705,
        title: 'Cladding Systems Engineering',
        description: 'Engineering solutions for stone, metal, and composite cladding systems, balancing aesthetics and durability.',
        image: '/assets/images/Icons/brickwall.png',
        benefits: [
          'Durable and Aesthetic Cladding',
          'Weather Resistance',
          'Cost-Effective Material Selection',
          'Code-Compliant Designs'
        ],
        process: [
          'Material selection and specification',
          'Structural analysis of cladding systems',
          'Design optimization for installation',
          'Fabrication and installation drawings'
        ]
      },
      {
        id: 706,
        title: 'Metal Louvers Design',
        description: 'Design and structural analysis of metal louvers for ventilation and aesthetic enhancement of commercial facades.',
        image: '/assets/images/Icons/menu.png',
        benefits: [
          'Improved Ventilation',
          'Aesthetic Customization',
          'Structural Durability',
          'Energy Efficiency Support'
        ],
        process: [
          'Functional and aesthetic requirement assessment',
          'Louver design and structural modeling',
          'Integration with facade systems',
          'Detailed fabrication documentation'
        ]
      },
      {
        id: 707,
        title: 'Glazing & General Shop Drawings',
        description: 'Detailed shop drawings for glazing and facade components, ensuring accurate fabrication and installation.',
        image: '/assets/images/Icons/drafting-compass.png',
        benefits: [
          'Precise Fabrication Instructions',
          'Streamlined Installation Process',
          'Code Compliance Documentation',
          'Reduced Construction Errors'
        ],
        process: [
          'Design review and specification',
          'Drafting of detailed drawings',
          'Coordination with fabricators',
          'Final approval and distribution'
        ]
      }
    ]
  },
  {
    id: 8,
    title: 'Commercial Sector: Steel & Aluminum Structures',
    previewDescription: 'Structural designs for staircases, railings, and more.',
    description: 'From staircases and guardrails to pergolas and railings, we provide structural designs and shop drawings that fit seamlessly into your workflow. Count on our expertise to meet the highest safety and compliance standards.',
    icon: '/assets/images/steel-aluminum-structures.jpg',
    bgImage: '/assets/images/steel-aluminum-structures.jpg',
    subServices: [
      {
        id: 801,
        title: 'Metal Staircases & Guardrails',
        description: 'Aesthetically pleasing and structurally sound metal staircase and guardrail designs for commercial and high-end applications.',
        image: '/assets/images/metal-staircases.jpg',
        benefits: [
          'Custom Designs for Unique Spaces',
          'Load Analysis for High Traffic Areas',
          'Code-Compliant Safety Features',
          'Material Optimization for Cost Efficiency'
        ],
        process: [
          'Design concept development',
          'Structural modeling and analysis',
          'Connection detail design',
          'Fabrication-ready documentation'
        ]
      },
      {
        id: 802,
        title: 'Elevator Hoist & Lifeline Beams',
        description: 'Structural analysis and design of elevator hoist beams and lifeline beams to ensure safety and compliance.',
        image: '/assets/images/Icons/wrench.png',
        benefits: [
          'High Load Capacity Designs',
          'Compliance with Safety Regulations',
          'Optimized Structural Solutions',
          'Seamless Integration with Building'
        ],
        process: [
          'Load requirement assessment',
          'Structural analysis and modeling',
          'Beam design and specification',
          'Installation documentation'
        ]
      },
      {
        id: 803,
        title: 'Fencing, Pergolas & Canopies',
        description: 'Design of fencing, pergolas, canopies, windscreens, and other building appurtenances for functionality and aesthetics.',
        image: '/assets/images/canopies-pergolas.jpg',
        benefits: [
          'Weather-Resistant Designs',
          'Wind and Snow Load Analysis',
          'Custom Aesthetic Options',
          'Integrated Drainage Solutions'
        ],
        process: [
          'Site analysis and requirement gathering',
          'Conceptual design development',
          'Structural engineering and verification',
          'Detailed fabrication documentation'
        ]
      },
      {
        id: 804,
        title: 'Glass Railing Systems - Frameless',
        description: 'Design of frameless glass railings with shoe base support for unobstructed views and modern aesthetics.',
        image: '/assets/images/glass-railings-frameless.jpg',
        benefits: [
          'Unobstructed Views',
          'Modern Aesthetic Appeal',
          'High Safety Standards',
          'Custom Hardware Options'
        ],
        process: [
          'Space and aesthetic assessment',
          'System design and customization',
          'Structural verification',
          'Installation detail preparation'
        ]
      },
      {
        id: 805,
        title: 'Glass Railing Systems - Point Supported',
        description: 'Point-supported glass railings designed for elegance and structural integrity.',
        image: '/assets/images/glass-railings-point.jpg',
        benefits: [
          'Minimalist Design',
          'High Structural Stability',
          'Custom Mounting Solutions',
          'Compliance with Safety Codes'
        ],
        process: [
          'Requirement and space assessment',
          'Point support system design',
          'Structural analysis and verification',
          'Detailed installation drawings'
        ]
      },
      {
        id: 806,
        title: 'Glass Railing Systems - Infill',
        description: 'Glass infill railings designed for safety and aesthetic integration in commercial spaces.',
        image: '/assets/images/glass-railings-infill.jpg',
        benefits: [
          'Enhanced Safety Features',
          'Aesthetic Versatility',
          'Durable Glass Panels',
          'Code-Compliant Designs'
        ],
        process: [
          'Design requirement evaluation',
          'Infill panel specification',
          'Structural and safety analysis',
          'Fabrication and installation documentation'
        ]
      },
      {
        id: 807,
        title: 'General Shop Drawings',
        description: 'Comprehensive shop drawings for steel and aluminum structures to ensure accurate fabrication and installation.',
      image: '/assets/images/Icons/drafting-compass.png',
        benefits: [
          'Detailed Fabrication Instructions',
          'Reduced Construction Errors',
          'Streamlined Installation',
          'Compliance Documentation'
        ],
        process: [
          'Design review and specification',
          'Drafting of detailed drawings',
          'Coordination with fabricators',
          'Final approval and distribution'
        ]
      }
    ]
  },
  {
    id: 9,
    title: 'Residential Sector',
    previewDescription: 'Engineering solutions for residential projects.',
    description: 'We provide engineering solutions designed to meet the unique demands of residential projects. Whether it’s permit-ready packages or high-end custom designs, we’ll simplify the process and keep your projects on track.',
    icon: '/assets/images/residential-sector.jpg',
    bgImage: '/assets/images/residential-sector.jpg',
    subServices: [
      {
        id: 901,
        title: 'Certified Wind Load Analysis',
        description: 'Certified wind load analysis tailored for residential structures to ensure safety and compliance with local codes.',
        image: '/assets/images/residential-wind-load.jpg',
        benefits: [
          'Site-Specific Analysis',
          'Code Compliance Assurance',
          'Enhanced Structural Safety',
          'Cost-Effective Solutions'
        ],
        process: [
          'Site data collection and assessment',
          'Wind load modeling and simulation',
          'Detailed analysis report',
          'Design optimization recommendations'
        ]
      },
      {
        id: 902,
        title: 'Residential Glazing Permit Packages',
        description: 'Comprehensive glazing packages providing all documentation needed for permitting and construction of residential window and door systems.',
        image: '/assets/images/residential-glazing.jpg',
        benefits: [
          'Permit-Ready Documentation',
          'Code-Compliant Designs',
          'Energy Efficiency Optimization',
          'Customized Solutions for Unique Homes'
        ],
        process: [
          'Project scope evaluation',
          'Code requirement identification',
          'Structural calculations and verification',
          'Drawing package preparation'
        ]
      },
      {
        id: 903,
        title: 'Glazing & Support Structures Analysis',
        description: 'Structural analysis of glazing and support structures for residential applications to ensure durability and safety.',
        image: '/assets/images/glazing-support-residential.jpg',
        benefits: [
          'Robust Structural Designs',
          'Compliance with Building Codes',
          'Optimized Material Usage',
          'Enhanced Aesthetic Integration'
        ],
        process: [
          'Load and structural requirement assessment',
          'Analysis of glazing and support systems',
          'Design optimization and verification',
          'Detailed documentation and specifications'
        ]
      },
      {
        id: 904,
        title: 'Special Inspector Services',
        description: 'Professional inspection services to verify installed residential systems comply with design specifications and building codes.',
        image: '/assets/images/special-inspection.jpg',
        benefits: [
          'Certification for Building Officials',
          'Identification of Installation Issues',
          'Compliance Documentation',
          'Quality Assurance'
        ],
        process: [
          'Pre-inspection documentation review',
          'On-site physical inspection',
          'Non-compliance identification and resolution',
          'Final report preparation'
        ]
      },
      {
        id: 905,
        title: 'Site-Specific Engineering',
        description: 'Custom engineering solutions addressing unique site conditions and field requirements for residential projects.',
        image: '/assets/images/site-specific-engineering.jpg',
        benefits: [
          'Tailored Design Solutions',
          'Adaptation to Unique Site Conditions',
          'Enhanced Project Feasibility',
          'Coordination with Local Requirements'
        ],
        process: [
          'Site condition assessment',
          'Custom engineering solution development',
          'Structural analysis and verification',
          'Implementation and documentation'
        ]
      }
    ]
  }
];

export const projects = [
   // ESW
   {
    id: 10,
    client: 'ESW',
    title: '20 Cambridgeside',
    description: '20 Cambridgeside is a commercial development with a focus on modern façade engineering. We delivered glazing structural calculations and cladding system designs.',
    year: 2021,
    location: 'Cambridge, MA',
    services: ['Glazing Structural Calculations', 'Cladding System Design'],
    images: [
      { src: '/assets/images/ESW/esw-cambridgeside-1.jpg', caption: 'Main façade with structural glazing.' },
      { src: '/assets/images/ESW/esw-cambridgeside-2.jpg', caption: 'Detail of cladding system.' },
      { src: '/assets/images/ESW/esw-cambridgeside-3.jpeg', caption: 'Interior glazing for office spaces.' }
    ]
  },
  {
    id: 11,
    client: 'ESW',
    title: '2000 Southbell',
    description: '2000 Southbell is a mixed-use project featuring custom glazing and cladding. Our team provided thermal analysis and shop drawings for a sustainable design.',
    year: 2022,
    location: 'Arlington, VA',
    services: ['Thermal Analysis', 'Shop Drawings', 'Glazing System Design'],
    images: [
      { src: '/assets/images/ESW/esw-southbell-4.webp', caption: 'Night view of illuminated façade.' },
      { src: '/assets/images/ESW/esw-southbell-1.jpg', caption: 'Exterior view of 2000 Southbell façade.' },
      { src: '/assets/images/ESW/esw-southbell-2.webp', caption: 'Glazing system details.' },
     
   
      { src: '/assets/images/ESW/esw-southbell-5.jpg', caption: 'Exterior view of 2000 Southbell façade.' },
      { src: '/assets/images/ESW/esw-southbell-6.jpg', caption: 'Glazing system details.' },
      { src: '/assets/images/ESW/esw-southbell-7.jpg', caption: 'Cladding installation process.' },
      { src: '/assets/images/ESW/esw-southbell-8.jpg', caption: 'Night view of illuminated façade.' },
      { src: '/assets/images/ESW/esw-southbell-9.jpg', caption: 'Exterior view of 2000 Southbell façade.' },
      { src: '/assets/images/ESW/esw-southbell-10.jpg', caption: 'Glazing system details.' },
      { src: '/assets/images/ESW/esw-southbell-11.jpg', caption: 'Cladding installation process.' },
    
    ]
  },
  {
    id: 12,
    client: 'ESW',
    title: 'Modera Parkside',
    description: 'Modera Parkside is a residential complex in Atlanta with modern glazing solutions. We provided permit-ready glazing packages and structural analysis.',
    year: 2023,
    location: 'Atlanta, GA',
    services: ['Permit-Ready Glazing Packages', 'Structural Analysis'],
    images: [
      { src: '/assets/images/ESW/esw-moderaparkside-1.jpg', caption: 'Main façade with residential glazing.' },
      { src: '/assets/images/ESW/esw-moderaparkside-2.jpg', caption: 'Balcony glazing details.' }
    ]
  },
  {
    id: 13,
    client: 'ESW',
    title: '80 E Rainey',
    description: '80 Erainey is a commercial building with advanced façade engineering. Our team delivered wind load analysis and cladding system designs for durability and aesthetics.',
    year: 2022,
    location: 'Boston, MA',
    services: ['Wind Load Analysis', 'Cladding System Design'],
    images: [
      { src: '/assets/images/ESW/esw-erainey-1.jpg', caption: 'Full façade view of 80 Erainey.' },
      { src: '/assets/images/ESW/esw-erainey-2.jpg', caption: 'Glazing system close-up.' },
      { src: '/assets/images/ESW/esw-erainey-3.jpg', caption: 'Cladding system installation.' },
      { src: '/assets/images/ESW/esw-erainey-4.jpg', caption: 'Completed façade with modern finishes.' }
    ]
  },
  {
    id: 14,
    client: 'ESW',
    title: 'West Wharf',
    description: 'West Wharf is a commercial project with a focus on sleek glazing systems. We provided shop drawings and structural calculations for a high-performance façade.',
    year: 2021,
    location: 'Washington, DC',
    services: ['Shop Drawings', 'Structural Calculations', 'Glazing System Design'],
    images: [
      { src: '/assets/images/ESW/esw-westwharf-1.jpg', caption: 'Exterior view of West Wharf façade.' },
      { src: '/assets/images/ESW/esw-westwharf-2.png', caption: 'Glazing system details.' }
    ]
  },
  {
    id: 15,
    client: 'ESW',
    title: 'Atlantic Ave',
    description: 'Atlantic Ave is a boutique commercial project with custom glazing. Our team provided glazing system design and shop drawings.',
    year: 2020,
    location: 'Boston, MA',
    services: ['Glazing System Design', 'Shop Drawings'],
    images: [
      { src: '/assets/images/ESW/esw-lostatlantic-1.png', caption: 'Main façade with custom glazing.' }
    ]
  },
  {
    id: 16,
    client: 'ESW',
    title: '930 McCarter',
    description: '930 McCarter is a large-scale commercial development featuring advanced façade solutions. We delivered wind load analysis and cladding system engineering.',
    year: 2023,
    location: 'Newark, NJ',
    services: ['Wind Load Analysis', 'Cladding System Engineering'],
    images: [
      { src: '/assets/images/ESW/esw-mccarter-1.jpg', caption: 'Full façade view of 930 McCarter.' },
      { src: '/assets/images/ESW/esw-mccarter-2.jpg', caption: 'Glazing system installation.' },
      { src: '/assets/images/ESW/esw-mccarter-3.jpg', caption: 'Cladding system details.' },
      { src: '/assets/images/ESW/esw-mccarter-4.jpg', caption: 'Completed façade at sunset.' }
    ]
  },
  // AAMG
  {
    id: 1,
    client: 'AAMG',
    title: 'Wynwood 29',
    description: 'Wynwood 29 is a vibrant mixed-use development in Miami’s arts district, featuring modern façade engineering with energy-efficient glazing systems and custom cladding. Our team provided wind load analysis and thermal performance optimization to ensure durability and sustainability.',
    year: 2022,
    location: 'Miami, FL',
    services: ['Wind Load Analysis', 'Thermal Performance Optimization', 'Glazing System Design'],
    images: [
      { src: '/assets/images/AAMG/aamg-wynwood29-1.jpg', caption: 'Main façade showcasing sleek glazing and cladding design.' },
      { src: '/assets/images/AAMG/aamg-wynwood29-2.jpg', caption: 'Corner view highlighting structural glazing details.' },
      { src: '/assets/images/AAMG/aamg-wynwood29-3.jpg', caption: 'Night view of illuminated façade with energy-efficient lighting.' },
      { src: '/assets/images/AAMG/aamg-wynwood29-4.jpg', caption: 'Close-up of custom metal cladding panels.' },
      { src: '/assets/images/AAMG/aamg-wynwood29-5.jpg', caption: 'Interior view of glazing system integration.' }
    ]
  },
  {
    id: 2,
    client: 'AAMG',
    title: 'Wynwood 27 & 28',
    description: 'Wynwood 27 & 28 are twin commercial buildings in Miami, designed with bold façade solutions. We delivered certified wind load analysis and glazing structural calculations to support high-rise requirements, ensuring aesthetic appeal and code compliance.',
    year: 2021,
    location: 'Miami, FL',
    services: ['Wind Load Analysis', 'Glazing Structural Calculations', 'Façade Design'],
    images: [
      { src: '/assets/images/AAMG/aamg-wynwood27-28-1.png', caption: 'Dual façade view of Wynwood 27 & 28.' },
      { src: '/assets/images/AAMG/aamg-wynwood27-28-2.png', caption: 'Structural glazing details on Wynwood 27.' },
      { src: '/assets/images/AAMG/aamg-wynwood27-28-3.png', caption: 'Wynwood 28’s cladding system under construction.' },
      { src: '/assets/images/AAMG/aamg-wynwood27-28-4.jpg', caption: 'Top-floor glazing with panoramic views.' },
      { src: '/assets/images/AAMG/aamg-wynwood27-28-5.jpg', caption: 'Integrated façade lighting design.' }
    ]
  },
  {
    id: 3,
    client: 'AAMG',
    title: 'i5 Wynwood',
    description: 'i5 Wynwood is a cutting-edge commercial project featuring advanced façade engineering. Our team provided glazing support structures and cladding systems engineering, optimized for Miami’s climate and aesthetic vibrancy.',
    year: 2023,
    location: 'Miami, FL',
    services: ['Glazing Support Structures', 'Cladding Systems Engineering'],
    images: [
      { src: '/assets/images/AAMG/aamg-i5wynwood-1.jpg', caption: 'Full façade view with modern glazing.' },
      { src: '/assets/images/AAMG/aamg-i5wynwood-2.jpg', caption: 'Detail of glazing support structures.' },
      { src: '/assets/images/AAMG/aamg-i5wynwood-3.png', caption: 'Cladding system installation process.' },
      { src: '/assets/images/AAMG/aamg-i5wynwood-4.png', caption: 'Interior glazing for open office spaces.' }
    ]
  },
  {
    id: 4,
    client: 'AAMG',
    title: 'Wynwood Haus',
    description: 'Wynwood Haus is a boutique residential building with a focus on sleek, modern design. We provided glazing system design and thermal analysis to enhance energy efficiency and resident comfort.',
    year: 2020,
    location: 'Miami, FL',
    services: ['Glazing System Design', 'Thermal Analysis'],
    images: [
      { src: '/assets/images/AAMG/aamg-wynwoodhaus-1.jpg', caption: 'Exterior view of Wynwood Haus façade.' },
      { src: '/assets/images/AAMG/aamg-wynwoodhaus-2.jpg', caption: 'Balcony glazing details.' }
    ]
  },
  
  // AGT Builders
  {
    id: 5,
    client: 'AGT Builders',
    title: 'Abbey Carpet',
    description: 'Abbey Carpet is a commercial renovation project featuring custom glazing and cladding systems. Our team delivered shop drawings and structural analysis to meet stringent design requirements.',
    year: 2021,
    location: 'Fort Lauderdale, FL',
    services: ['Shop Drawings', 'Structural Analysis', 'Cladding System Design'],
    images: [
      { src: '/assets/images/AGT/agt-abbeycarpet-1.jpg', caption: 'Main entrance with custom glazing.' },
      { src: '/assets/images/AGT/agt-abbeycarpet-2.jpg', caption: 'Interior glazing for showroom.' },
      { src: '/assets/images/AGT/agt-abbeycarpet-3.jpg', caption: 'Cladding system on exterior walls.' },
      { src: '/assets/images/AGT/agt-abbeycarpet-4.jpg', caption: 'Completed façade with modern finishes.' }
    ]
  },
  // Berger Window and Doors
  {
    id: 6,
    client: 'Berger Window and Doors',
    title: 'Coastal Towers Lobby',
    description: 'The Coastal Towers Lobby renovation featured high-performance glazing systems. We provided structural calculations and shop drawings to ensure seamless integration and durability.',
    year: 2022,
    location: 'Sunny Isles Beach, FL',
    services: ['Structural Calculations', 'Shop Drawings', 'Glazing System Design'],
    images: [
      { src: '/assets/images/BER/berger-coastaltowers-1.jpg', caption: 'Lobby entrance with floor-to-ceiling glazing.' },
      { src: '/assets/images/BER/berger-coastaltowers-2.jpg', caption: 'Interior view of glazing system.' }
    ]
  },
  {
    id: 7,
    client: 'Berger Window and Doors',
    title: 'Mystic Pointe 200',
    description: 'Mystic Pointe 200 involved upgrading residential glazing systems. Our team delivered permit-ready glazing packages tailored to coastal conditions.',
    year: 2020,
    location: 'Aventura, FL',
    services: ['Permit-Ready Glazing Packages', 'Glazing System Design'],
    images: [
      { src: '/assets/images/BER/berger-mysticpointe-1.jpg', caption: 'Exterior glazing for residential units.' }
    ]
  },
  // Eco Window
  {
    id: 8,
    client: 'Eco Window',
    title: 'Royal Palm Residences',
    description: 'Royal Palm Residences is a luxury residential project with energy-efficient glazing solutions. We provided thermal analysis and custom glazing designs to meet LEED standards.',
    year: 2023,
    location: 'Boca Raton, FL',
    services: ['Thermal Analysis', 'Custom Glazing Design', 'LEED Compliance'],
    images: [
      { src: '/assets/images/ECO/eco-royalpalm-1.jpg', caption: 'Main façade with energy-efficient glazing.' },
      { src: '/assets/images/ECO/eco-royalpalm-2.jpg', caption: 'Balcony glazing with ocean views.' },
      { src: '/assets/images/ECO/eco-royalpalm-3.jpg', caption: 'Interior glazing for penthouse units.' }
    ]
  },
  {
    id: 9,
    client: 'Eco Window',
    title: 'Metro RARC',
    description: 'Metro RARC is a commercial project featuring advanced glazing systems. Our team provided wind load analysis and shop drawings for a durable, modern façade.',
    year: 2022,
    location: 'Miami, FL',
    services: ['Wind Load Analysis', 'Shop Drawings', 'Glazing System Design'],
    images: [
      { src: '/assets/images/ECO/eco-metrorarc-1.jpg', caption: 'Full façade view of Metro RARC.' },
      { src: '/assets/images/ECO/eco-metrorarc-2.jpg', caption: 'Close-up of glazing system.' },
      { src: '/assets/images/ECO/eco-metrorarc-3.jpg', caption: 'Construction phase of façade installation.' }
    ]
  },
 
  // Strom Frame Window & Doors
  {
    id: 17,
    client: 'Strom Frame Window & Doors',
    title: 'King’s College Bahamas',
    description: 'King’s College Bahamas is an educational facility with modern glazing systems. Our team provided structural calculations and shop drawings for a durable, aesthetic façade.',
    year: 2022,
    location: 'Nassau, Bahamas',
    services: ['Structural Calculations', 'Shop Drawings', 'Glazing System Design'],
    images: [
      { src: '/assets/images/STRM/strom-kingscollege-1.jpeg', caption: 'Main building façade with glazing.' },
      { src: '/assets/images/STRM/strom-kingscollege-2.jpeg', caption: 'Interior glazing for classrooms.' },
      { src: '/assets/images/STRM/strom-kingscollege-3.jpeg', caption: 'Completed façade with modern design.' }
    ]
  }
];
export const clients = [
  '/assets/images/client1.webp',
  '/assets/images/client2.webp',
   
  '/assets/images/client3.png',
  '/assets/images/client4.png',
  '/assets/images/client5.png',
  '/assets/images/client6.jpg',
 
];

export const testimonials = [
    {
    id: 6,
    name: "Matt Thomas",
    position: "",
    company: "",
    quote: "AGT Builders experience with Façade Connection and Carlos Martinez has been nothing short of outstanding. The quality of their work is unparalleled, they are responsive, and super customer oriented. We feel lucky to have them as a resource.",
    logo:"/assets/images/agt_logo.png"
  },
 

  {
    id: 3,
    name: "Ianko Diaz",
    position: "",
    company: "",
    quote: "The Facade Connection Corporation is a reliable and experienced company that specializes in the design and development of glass and glazing related products and projects. I have worked with them on several projects, and I can attest to their high-quality workmanship, timely delivery, and competitive pricing. They have a team of skilled and certified engineers and designers who can handle any type of glass and glazing projects, from simple windows and doors to complex curtain walls and skylights. They are always up to date with the latest industry standards and codes. The Facade Connection Corporation is a company that I would highly recommend to anyone looking for a professional and trustworthy partner in the glass and glazing industry.",
    logo:"/assets/images/century-logo.png"
  },
  {
    id: 4,
    name: "Iordan Diaz",
    position: "",
    company: "",
    quote: "The Facade Connection is the company you can trust for your engineering projects. A great team of professionals led by Carlos Martínez, capable of delivering experience and efficiency in a single service, regardless of the size of the challenge to be overcome. Simply, a good engineering team that will help you achieve the desired success.",
    logo:"/assets/images/sap-logo.png"
  },
  {
    id: 5,
    name: "Alex Hassun",
    position: "",
    company: "",
    quote: "I have known Carlos for over 6 years now. Working with Carlos and the Facade Connection has been a great experience. Carlos is very knowledgeable and has helped me immensely, He is always there to pick up the phone when needed and has no issues answering any questions I have. I highly recommend them.",
    logo:"/assets/images/sap-logo.png"
  },
   {
    id: 1,
    name: "Eric Sami",
    position: "General Contractor",
    company: "",
    quote: "The Facade Connection were recommended by our subcontractor to produce some structural engineering and calculations. Carlos was excellent in working with us as a team to understand what we needed, provide value engineering to keep our cost down while being accurate in his design which passed all Engineering and County appovals on the first round. His whole team work very hard to meet our aggressive deadline and were communicating with us every step of the way. We are a General Contractor with 40 years of experience and we recommend The Facade Connection 100%.",
    logo:"/assets/images/logo-aarya.jpg"
  },
    {
    id: 2,
    name: "Gurjiwan Singh",
    position: "",
    company: "",
    quote: "I have had the pleasure of working with The Facade Connection, a facade design and engineering firm, and I am thoroughly impressed with the level of professionalism and expertise they demonstrated throughout the entire process. The team led by Carlos Martinez exhibited a deep understanding of curtain wall design. I highly recommend The Facade Connection for any facade design and engineering needs. Their combination of expertise, communication skills and commitment sets them apart in the industry. Working with TFC was a positive experience, and I look forward to future collaborations."
  },

];

export const processSteps = [
  {
    id: 1,
    title: 'Discovery & Planning',
    description: 'We analyze project requirements, site conditions, and client objectives to create a tailored engineering plan.',
    icon: { name: 'Search' }
  },
  {
    id: 2,
    title: 'Conceptual Design',
    description: 'Our team develops initial structural concepts, incorporating innovative and sustainable solutions.',
    icon: { name: 'Lightbulb' }
  },
  {
    id: 3,
    title: 'Detailed Engineering',
    description: 'We create detailed designs and specifications using advanced BIM and analysis tools.',
    icon: { name: 'Palette' }
  },
  {
    id: 4,
    title: 'Construction Support',
    description: 'We provide on-site support and supervision to ensure designs are implemented accurately.',
    icon: { name: 'Code' }
  },
  {
    id: 5,
    title: 'Quality Assurance',
    description: 'Rigorous testing and inspections ensure the structure meets safety and performance standards.',
    icon: { name: 'CheckCircle' }
  },
  {
    id: 6,
    title: 'Project Handover',
    description: 'We deliver final documentation and provide ongoing support for maintenance and operations.',
    icon: { name: 'Rocket' }
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Alex Johnson',
    position: 'CEO & Founder',
    shortBio: 'With over 25 years in structural engineering, Alex leads with a vision for innovation and sustainability.',
    photo: '/images/team/alex.jpg',
    socialLinks: [
      { url: 'https://linkedin.com', icon: { name: 'Linkedin' } },
      { url: 'https://twitter.com', icon: { name: 'Twitter' } }
    ]
  },
  {
    id: 2,
    name: 'Sarah Chen',
    position: 'Chief Engineer',
    shortBio: 'Sarah specializes in seismic design and has led numerous high-profile projects.',
    photo: '/images/team/sarah.jpg',
    socialLinks: [
      { url: 'https://linkedin.com', icon: { name: 'Linkedin' } }
    ]
  },
  {
    id: 3,
    name: 'Michael Rodriguez',
    position: 'Lead Structural Designer',
    shortBio: 'Michael’s expertise in BIM technology ensures precision in complex designs.',
    photo: '/images/team/michael.jpg',
    socialLinks: [
      { url: 'https://linkedin.com', icon: { name: 'Linkedin' } },
      { url: 'https://twitter.com', icon: { name: 'Twitter' } }
    ]
  },
  {
    id: 4,
    name: 'Priya Patel',
    position: 'Project Manager',
    shortBio: 'Priya excels at coordinating teams and delivering projects on time and within budget.',
    photo: '/images/team/priya.jpg',
    socialLinks: [
      { url: 'https://linkedin.com', icon: { name: 'Linkedin' } }
    ]
  }
];

export const awards = [
  {
    id: 1,
    name: 'Best Structural Engineering Firm',
    year: '2024',
    description: 'Recognized for outstanding project delivery and innovation by the Engineering Excellence Awards.',
    icon: '/assets/icons/award1.svg'
  },
  {
    id: 2,
    name: 'Sustainable Design Award',
    year: '2023',
    description: 'Awarded for eco-friendly structural solutions by the Green Building Council.',
    icon: '/assets/icons/award2.svg'
  },
  {
    id: 3,
    name: 'Innovation in Engineering',
    year: '2023',
    description: 'Honored for pioneering use of BIM technology by the Structural Engineers Association.',
    icon: '/assets/icons/award3.svg'
  },
  {
    id: 4,
    name: 'Project of the Year',
    year: '2022',
    description: 'Recognized for the Wynwood 29 project by the National Engineering Awards.',
    icon: '/assets/icons/award4.svg'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What types of projects do you handle?',
    answer: 'We handle a wide range of projects, including commercial buildings, residential complexes, and educational facilities, with a focus on façade engineering and glazing systems.'
  },
  {
    id: 2,
    question: 'How long does a typical project take?',
    answer: 'Project timelines vary based on scope and complexity. A standard façade design might take 3-6 months, while large commercial projects can take 1-2 years.'
  },
  {
    id: 3,
    question: 'What is your approach to sustainability?',
    answer: 'We prioritize energy-efficient glazing, thermal optimization, and green building certifications like LEED to minimize environmental impact.'
  },
  {
    id: 4,
    question: 'Do you offer post-construction support?',
    answer: 'Yes, we provide maintenance plans, structural inspections, and ongoing consulting to ensure long-term performance.'
  },
  {
    id: 5,
    question: 'How do you ensure project safety?',
    answer: 'We adhere to strict safety standards, conduct rigorous wind load and structural analysis, and use advanced BIM tools to ensure integrity.'
  },
  {
    id: 6,
    question: 'Can you work with international clients?',
    answer: 'Yes, we have experience with international projects, such as King’s College Bahamas, and comply with global engineering standards.'
  }
];